import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import axios from 'axios';
import CloseIcon from '@mui/icons-material/Close';
import {
    Button,
    Card,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    styled,
    Typography,
} from '@mui/material';
import CardHeader from '@mui/material/CardHeader';
import IconButton from '@mui/material/IconButton';
import { Box } from '@mui/system';
import { format, parseISO } from 'date-fns';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import TitleCase from '../components/BasicComponents/TitleCase';
import BookingHeader from '../components/BookingInfo/BookingHeader';
import Documents from '../components/BookingInfo/Documents';
import Qualifications from '../components/BookingInfo/Qualifications';
import CrtAvailability from '../components/Calendar/CrtAvailability';
import GradeDropDown from '../components/CustomDropDown/GradeDropDown';
import TeacherMultiDropDown from '../components/CustomDropDown/TeacherMultiDropDown';
import TimeDropDown from '../components/CustomDropDown/TimeDropDown';
import Loading from '../components/Loading';
import CircularIntegration from '../components/ProgressComplete';
import { addBooking, resetAddBookingStatus } from '../redux/BookingSlice';
import { getSchoolTeachers } from '../redux/SchoolSlice';
import { Link, Link as RouterNavLink } from 'react-router-dom';

// const useStyles = makeStyles(theme => ({
//     // teacherCardInfo: {
//     //     order: 2,
//     //     // [theme.breakpoints.up('sm')]: {
//     //     //     order: 1,
//     //     // },
//     // },
//     // bookingDateValue: {
//     //     padding: '0 0 10px 4px',
//     // },
// }));

const Image = styled('img')(({ theme }) => ({
    maxWidth: '100%',
    maxHeight: '100%',
    borderRadius: '10px',
    [theme.breakpoints.only('sm')]: {
        maxWidth: '400px',
    },
    [theme.breakpoints.up('md')]: {
        maxWidth: '500px',
    },
}));

// const RootGrid = styled(Grid)(({ theme }) => ({
//     '& > *': {
//         marginTop: theme.spacing(1),
//         marginBottom: theme.spacing(1),
//     },
// }));

const RootGrid = styled(Grid)(({ theme }) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(2),
}));

const BookingDateGrid = styled(Grid)(({ theme }) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
}));

const AvailableFromGrid = styled(Grid)(({ theme }) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
}));

const TeacherCard = styled('div')(({ theme }) => ({
    margin: '20px 20px 40px',
    padding: '20px',
}));

const TeacherCardGrid = styled(Card)(({ theme }) => ({
    width: '100%',
    margin: '20px auto',
    textAlign: 'center',
    order: 1,
    padding: '30px',
    // [theme.breakpoints.up('sm')]: {
    //     order: 2,
    //     margin: '15px',
    // },
}));
const BookingButton = styled(Button)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '150px',
    borderRadius: '30px',
}));

const HeadingType = styled(Typography)(({ theme }) => ({
    marginBottom: '15px',
}));

const validPermission = 'create:booking';

const BookingCard = styled(Card)(({ theme }) => ({
    paddingTop: '12px',
    marginRight: '12px',
    height: '100%',
    [theme.breakpoints.down('md')]: {
        marginRight: '0px',
    },
}));

const GridBorder = styled(Grid)(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        marginBottom: '20px',
        'padding-bottom': '20px',
    },
}));

/**
 * Component for entering in a mobile number.
 *
 * @component CreateBooking
 * @param {object} props props
 * @param {object} props.teacher
 * @param {bool} props.teacher.getTeacherStatus
 * @param {object} props.teacher.teacherInSchool
 * @param {object} props.teacher.teacherInSchool.Data
 * @param {object} props.teacher.school
 * @param {object} props.teacher.school.Data
 * @param {string} props.teacher.school.Data.pk1
 * @param {object} props.avail
 * @param {object} props.avail.responseVals
 * @param {object} props.avail.responseVals.id
 * @param {string} props.avail.responseVals.id.pk1
 * @param {string} props.avail.responseVals.id.sk1
 * @param {[string]} props.avail.responseVals.id.grades
 * @param {[string]} props.avail.responseVals.id.skills
 * @param {string} props.avail.responseVals.id.otherSkills
 * @param {date} props.avail.responseVals.id.startDate
 * @param {date} props.avail.responseVals.id.endDate
 * @param {string} props.avail.responseVals.id.bio
 * @param {number} props.avail.responseVals.id.rating
 * @param {number} props.avail.responseVals.id.amountOfRatings
 * @param {string} props.avail.responseVals.id.teacherProfile URL for the teacher profile image
 * @param {string} props.avail.responseVals.id.teacherFirstName
 * @param {string} props.avail.responseVals.id.teacherLastName
 * @param {string} props.avail.responseVals.id.gs1pk
 * @param {func} props.removeItem
 * @param {string} props.removeItem.id
 * @return (
 * <CreateBooking/>
 * )
 */
export const CreateBooking = props => {
    // const classes = useStyles();
    let { id } = useParams();
    const searchParams = new URLSearchParams(document.location.search);
    const searchDate = new Date(searchParams.get('date'));
    const searchYear = searchParams.get('year');
    const searchSize = searchParams.get('size');
    //const id = 0;

    const { getAccessTokenSilently } = useAuth0();

    const { token } = useSelector(state => state.token);
    const tokenStatus = useSelector(state => state.token.status);
    const { booking } = useSelector(state => state.booking);
    const bookingStatus = useSelector(state => state.booking.addStatus);

    const dispatch = useDispatch();

    let history = useHistory();

    const [state, setState] = useState({
        teachersInSchool: {
            value: [],
            error: '',
            errorCode: '',
        },
        grade: [],
        processingBooking: 0,
        bookingResponse: '',
        avail: {},
    });
    const [apiMessage, setApiMessage] = useState('Unable to process booking');

    const [message, setMessage] = useState('');

    const [timeError, setTimeError] = useState(false);
    const [outsideDialog, setOutsideDialog] = useState(false);
    const [schoolState, setSchoolState] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const startMoment = moment(state.startTime, 'h:mm a');
        const endMoment = moment(state.endTime, 'h:mm a');
        setTimeError(startMoment >= endMoment);
    }, [state.startTime, state.endTime]);

    useEffect(() => {
        if (tokenStatus === 'succeeded' && token.Count === 1) {
            if (token.permissions.includes(validPermission) === false)
                setState({
                    ...state,
                    redirectToHome: true,
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tokenStatus, token.Count, token.permissions]);

    useEffect(() => {
        if (props.teacher.getTeacherStatus === 'idle') {
            async function dispatchSchoolTeachersFromStore() {
                const token = await getAccessTokenSilently({
                    scope: process.env.REACT_APP_scope,
                });
                const requestData = {
                    'token': token,
                };

                //doesn't seem to work on Safari - need to troubleshoot
                dispatch(getSchoolTeachers(requestData));
            }
            dispatchSchoolTeachersFromStore();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.teacher.getTeacherStatus, props.teacher.teachersInSchool.Data]);

    useEffect(() => {
        if (typeof props.teacher.school.Data.address !== 'undefined') {
            const schoolAddress = props.teacher.school.Data.address;

            setSchoolState(schoolAddress.match(/\b([A-Z]{2,3})\b/)[1]);
        }
    }, [props.teacher]);

    useEffect(() => {
        console.log('Use effect called for booking completed', bookingStatus);
        if (bookingStatus === 'succeeded') {
            props.removeItem(id);
            setState({
                ...state,
                bookingResponse: booking,
                processingBooking: 2,
            });
        } else if (bookingStatus === 'failed') {
            setState({
                ...state,
                processingBooking: 3,
            });
        } else if (bookingStatus === 'idle') {
            setState({
                ...state,
                processingBooking: 0,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bookingStatus]);

    useEffect(() => {
        if (
            props.avail.responseVals.filter(data => data.uniqueId === id)
                .length > 0
        ) {
            const availState = props.avail.responseVals.filter(
                data => data.uniqueId === id
            );
            console.log('availState', availState[0]);
            var starterTime = format(
                parseISO(availState[0].startDate),
                'h:mm aaa'
            );
            var enderTime = format(parseISO(availState[0].endDate), 'h:mm aaa');

            setState({
                ...state,
                avail: availState[0],
                startTime: starterTime,
                endTime: enderTime,
                earliestTime: starterTime,
                latestTime: enderTime,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.avail.responseVals]);

    function goBack() {
        history.push('/book-teacher');
        dispatch(resetAddBookingStatus());
    }

    /**
     *
     * @param {school} school
     * @returns {Object{error: bool, errorMessage: string}}
     */
    function validateSchool(school) {
        if (
            typeof school.address !== 'undefined' &&
            typeof school.description !== 'undefined' &&
            typeof school.displayName !== 'undefined' &&
            typeof school.lat !== 'undefined' &&
            typeof school.lng !== 'undefined' &&
            typeof school.schoolLogo !== 'undefined' &&
            typeof school.pk1 !== 'undefined'
        ) {
            console.log('Error false');
            return { error: false, errorMessage: '' };
        } else {
            console.log('Error true');
            var missingVars = '';
            if (typeof school.schoolLogo === 'undefined') {
                missingVars = missingVars + 'School Logo ';
            }
            if (typeof school.description === 'undefined') {
                missingVars = missingVars + 'School Description ';
            }
            if (typeof school.displayName === 'undefined') {
                missingVars = missingVars + 'School Name ';
            }
            if (
                typeof school.lat === 'undefined' ||
                typeof school.lng === 'undefined' ||
                typeof school.address === 'undefined'
            ) {
                missingVars = missingVars + 'School Address ';
            }

            return {
                error: true,
                errorMessage: `Missing school information: ${missingVars}`,
            };
        }
    }

    const processBooking = async appointment => {
        try {
            setState({
                ...state,
                processingBooking: 1,
            });
            const schoolData = props.teacher.school.Data;

            const validSchool = validateSchool(schoolData);
            if (validSchool.error === true) {
                setMessage(validSchool.errorMessage);
                throw new Error('Could not Validate School');
            }
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            let requestData = {};

            if (state.teachersInSchool.value.length === 0) {
                requestData = {
                    token: token,
                    request: {
                        availabilityId: state.avail['pk1'],
                        availabilityRef: state.avail['sk1'],
                        startTime: state.startTime,
                        endTime: state.endTime,
                        grade: state.grade,
                    },
                };
            } else {
                let fillInTeachers;

                fillInTeachers = props.teacher.teachersInSchool.Data.filter(
                    teacher =>
                        state.teachersInSchool.value.indexOf(teacher.pk1) > -1
                );

                requestData = {
                    token: token,
                    request: {
                        availabilityId: state.avail['pk1'],
                        availabilityRef: state.avail['sk1'],
                        teacherId: fillInTeachers,
                        startTime: state.startTime,
                        endTime: state.endTime,
                        grade: state.grade,
                    },
                };
            }
            const outcome = await dispatch(addBooking(requestData));

            if (
                outcome.error?.message === 'Request failed with status code 402'
            ) {
                setApiMessage('Booking credits are depleated');
                console.log('outcome', outcome.error.message);
            }
        } catch (err) {
            let errorText = 'Unable to Process Booking';
            if (err.error?.message === 'Request failed with status code 402') {
                errorText = 'Booking credits are depleated';
            }
            console.log(errorText, err);
            setApiMessage(errorText);
        }
    };

    const outsideAvailabilityCheck = () => {
        setOutsideDialog(true);
    };

    const handleCloseDialog = () => {
        setOutsideDialog(false);
    };

    const handleEndTimeChange = event => {
        setState({
            ...state,
            endTime: event.target.value,
        });
    };

    const handleStartTimeChange = event => {
        setState({
            ...state,
            startTime: event.target.value,
        });
    };

    const handleGradeChange = value => {
        setState({
            ...state,
            grade: value,
        });
    };

    const handleSelect = value => {
        var itemStruct = {
            value: value,
            touched: true,
        };
        setState({
            ...state,
            teachersInSchool: itemStruct,
        });
    };

    function isValidDate(d) {
        return d instanceof Date && !isNaN(d);
    }

    useEffect(async () => {
        if (
            typeof props.teacher.school !== 'undefined' &&
            typeof state.avail.teacherProfile === 'undefined'
        ) {
            if (
                isValidDate(searchDate) &&
                searchSize !== null &&
                searchYear !== null
            ) {
                if (props.avail.responseVals.length === 0)
                    props.searchAvail(searchDate, searchYear, searchSize);
                else if (
                    props.avail.responseVals.filter(
                        data => data.uniqueId === id
                    ).length === 0 ||
                    props.avail.count === 0
                )
                    goBack();
            } else {
                goBack();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.teacher.school, props.avail.responseVals]);

    let content;

    if (state.redirectToHome === true) {
        content = <Redirect to="/home" />;
    } else if (state.processingBooking !== 0) {
        content = (
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
            >
                <TeacherCardGrid>
                    <HeadingType variant="h2">Processing Booking</HeadingType>
                    {typeof state.avail.teacherProfile !== 'undefined' && (
                        <Grid item xs={12}>
                            <Image
                                src={state.avail.teacherProfile}
                                alt={
                                    'Profile Image user ' +
                                    state.avail.teacherFirstName
                                }
                            />
                            <TitleCase
                                variant="h3"
                                sx={{ m: 2 }}
                                string={`${state.avail.teacherFirstName} ${state.avail.teacherLastName}`}
                            />
                        </Grid>
                    )}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <CircularIntegration
                            loading={
                                state.processingBooking === 1 ? true : false
                            }
                            success={
                                state.processingBooking === 2 ? true : false
                            }
                            failed={
                                state.processingBooking === 3 ? true : false
                            }
                            successMessage="Booking Registered"
                            failedMessage={apiMessage}
                            sx={{
                                padding: '100px 0px',
                            }}
                        ></CircularIntegration>
                    </Box>
                    {apiMessage === 'Booking credits are depleated' ? (
                        <Box>
                            <Typography variant="h6" sx={{ m: 2 }}>
                                Update{' '}
                                <Link to="/profile/billing">
                                    subscription plan
                                </Link>{' '}
                                for unlimited bookings
                            </Typography>
                        </Box>
                    ) : (
                        <Box></Box>
                    )}
                    <BookingButton
                        onClick={goBack}
                        variant="outlined"
                        color="secondary"
                    >
                        Back
                    </BookingButton>
                </TeacherCardGrid>
            </Grid>
        );
    } else {
        content = (
            <div>
                <Grid
                    container
                    xs={12}
                    directon="column-reverse"
                    alignItems="stretch"
                >
                    <BookingHeader
                        booking={{
                            'status': state.avail.status,
                            'teacherProfile': state.avail.teacherProfile,
                            'teacherFirstName': state.avail.teacherFirstName,
                            'teacherLastName': state.avail.teacherLastName,
                            'teacherBio': state.avail.bio,
                        }}
                        licenceList={state.avail.licenceList}
                        schoolState={schoolState}
                        teacherRating={state.avail.rating}
                        teacherRatingAmount={state.avail.amountOfRatings}
                        userType="School"
                    />
                </Grid>

                <Grid container xs={12}>
                    <GridBorder item xs={12} md={6}>
                        <BookingCard>
                            {/* <Grid item xs={12} sm={8}> */}
                            <RootGrid container xs={12}>
                                <BookingDateGrid item xs={12} sm={4} md={5}>
                                    <Typography variant="h6">
                                        Booking Date:
                                    </Typography>
                                </BookingDateGrid>
                                <AvailableFromGrid item xs={12} sm={6} md={5}>
                                    {state.avail.startDate !== undefined && (
                                        <Typography
                                            variant="h5"
                                            display="inline"
                                        >
                                            {format(
                                                parseISO(state.avail.startDate),
                                                'dd MMM YYY'
                                            )}
                                            {/* state.avail.startDate */}
                                        </Typography>
                                    )}
                                </AvailableFromGrid>
                            </RootGrid>

                            <RootGrid container xs={12}>
                                <Grid item xs={12} sm={4} md={5}>
                                    <Typography variant="h6">
                                        Available:
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6} md={5}>
                                    {state.avail.startDate !== undefined && (
                                        <Typography
                                            variant="h5"
                                            display="inline"
                                        >
                                            {format(
                                                parseISO(state.avail.startDate),
                                                'h:mma'
                                            )}
                                            {' - '}
                                            {format(
                                                parseISO(state.avail.endDate),
                                                'h:mma'
                                            )}
                                            {/* state.avail.startDate */}
                                        </Typography>
                                    )}
                                </Grid>
                            </RootGrid>

                            <RootGrid container xs={11}>
                                <TimeDropDown
                                    id="startTime"
                                    title="Start Time"
                                    defaultTime={state.startTime}
                                    handleTimeChange={handleStartTimeChange}
                                    error={timeError}
                                />
                            </RootGrid>

                            <RootGrid container xs={11}>
                                <TimeDropDown
                                    id="endTime"
                                    title="End Time"
                                    defaultTime={state.endTime}
                                    handleTimeChange={handleEndTimeChange}
                                    error={timeError}
                                    errorText={'Booking times are invalid'}
                                />
                            </RootGrid>

                            <RootGrid container xs={11}>
                                <GradeDropDown
                                    title="Grade"
                                    subtitle="Select grade level"
                                    grade={state.grade}
                                    schoolGrades={state.avail.grades}
                                    handleGrade={handleGradeChange}
                                />
                            </RootGrid>

                            {typeof props.teacher.teachersInSchool.Data !==
                                'undefined' && (
                                <RootGrid container xs={11}>
                                    <TeacherMultiDropDown
                                        id="teacherInSchool"
                                        selectedTeachers={
                                            state.teachersInSchool.value
                                        }
                                        teachers={
                                            props.teacher.teachersInSchool.Data
                                        }
                                        handleSelect={handleSelect}
                                        subtitle="Select Replacement Teacher"
                                        title="Classroom Teacher (OPTIONAL):"
                                        compareValue="pk1"
                                        loadingStatus={
                                            props.teacher.getTeacherStatus
                                        }
                                    />
                                </RootGrid>
                            )}

                            {message === '' ? (
                                <RootGrid container xs={11}>
                                    <BookingButton
                                        onClick={
                                            moment(state.startTime, 'h:mm a') <
                                                moment(
                                                    state.earliestTime,
                                                    'h:mm a'
                                                ) ||
                                            moment(state.endTime, 'h:mm a') >
                                                moment(
                                                    state.latestTime,
                                                    'h:mm a'
                                                )
                                                ? outsideAvailabilityCheck
                                                : processBooking
                                        }
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        disabled={timeError}
                                    >
                                        Book
                                    </BookingButton>
                                    <BookingButton
                                        onClick={goBack}
                                        variant="outlined"
                                        color="secondary"
                                        size="large"
                                    >
                                        Back
                                    </BookingButton>
                                    <Dialog
                                        open={outsideDialog}
                                        onClose={handleCloseDialog}
                                    >
                                        <DialogTitle id="alert-dialog-title">
                                            {'Are you sure?'}
                                        </DialogTitle>
                                        <DialogContent>
                                            <DialogContentText id="alert-dialog-description">
                                                You have requested for booking
                                                times outside the teacher's
                                                availability! This will likely
                                                result in a declined booking.
                                                Continue?
                                            </DialogContentText>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={handleCloseDialog}>
                                                Disagree
                                            </Button>
                                            <Button
                                                onClick={() => {
                                                    handleCloseDialog();
                                                    processBooking();
                                                }}
                                            >
                                                Agree
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                </RootGrid>
                            ) : (
                                <Box>
                                    <Typography
                                        variant="h6"
                                        color="error"
                                        align="center"
                                        sx={{ margin: '20px' }}
                                    >
                                        <Box>{message}</Box>
                                        <BookingButton
                                            variant="outlined"
                                            color="secondary"
                                            size="large"
                                            sx={{ maxWidth: '200px' }}
                                            onClick={() => {
                                                history.push(
                                                    '/profile/schoolInfo'
                                                );
                                            }}
                                        >
                                            Edit School Profile
                                        </BookingButton>
                                    </Typography>
                                </Box>
                            )}
                        </BookingCard>
                    </GridBorder>
                    <Qualifications
                        skills={state.avail.skills}
                        otherSkills={state.avail.otherSkills}
                        grades={state.avail.grades}
                        gs1pk={state.avail['gs1-pk']}
                        schoolId={props.teacher.school.Data.pk1}
                    />
                </Grid>

                <Grid
                    container
                    xs={12}
                    directon="column-reverse"
                    alignItems="stretch"
                    sx={{ marginTop: '30px' }}
                >
                    {(state.avail['gs1-pk'] !== undefined &&
                        props.teacher.school.Data !== undefined) ||
                        (state.avail['gs1-pk'] !== undefined && (
                            <Documents
                                gs1pk={state.avail['gs1-pk']}
                                schoolId={props.teacher.school.Data.pk1}
                                loadOnInit={true}
                                filterResume={false}
                            />
                        ))}
                </Grid>

                <Grid container>
                    <CrtAvailability
                        searchDate={state.avail.startDate}
                        reduced
                        id={state.avail['gs1-pk']}
                    />
                </Grid>
            </div>
        );
    }

    return (
        <Grid
            container
            directon="row"
            justifyContent="center"
            alignItems="center"
        >
            <Grid item xs={12} sm={10}>
                <TeacherCard>
                    <CardHeader
                        sx={{ 'padding': '0px' }}
                        action={
                            <IconButton
                                onClick={goBack}
                                aria-label="settings"
                                size="large"
                            >
                                <CloseIcon />
                            </IconButton>
                        }
                    />

                    {typeof state.avail.teacherProfile === 'undefined' ? (
                        <Loading />
                    ) : (
                        content
                    )}
                </TeacherCard>
            </Grid>
        </Grid>
    );
};

export default withAuthenticationRequired(CreateBooking, {
    onRedirecting: () => <Loading />,
});
